<template>
  <SidebarRight>
    <div>
      <div class="px-8">
        <TitleSubIconGap
          :title="data.namapetani"
          titleColor="text-white"
          :subtitle="'ID Petani :' + ' ' + data.petaniid"
        >
          <IconGeofence size="w-12 h-12" />
        </TitleSubIconGap>
        <TittleBetween addClass="pt-8 pb-5" title="Basic Info" />
      </div>

      <div
        class="flex flex-col space-y-3 px-8 max-h-[500px] overflow-y-auto text-white text-sm pb-5"
      >
        <div class="flex gap-2">
          <div class="w-[98px]">Kode Petak</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.kode_petak }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Area</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.area_id }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Desa</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.desa_id }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Lahan</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.lahanid }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">No Kontrak</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.nokontrak }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Luas (Ha)</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.luasha }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Luas Tanam</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.luastanam }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Tahun Tanam</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.tahuntanam }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Bulan Tanam</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.bulantanam }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Masa Tanam</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.masatanam }}</div>
        </div>

        <div class="flex gap-2">
          <div class="whitespace-nowrap pr-3">Nama Kebun</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.namakebun }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">PABRIK GULA</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.pabrik_gul }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Pabrik Gula</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.pabrikgula }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Kategori</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.kategori }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Jenis Kategori</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.jeniskateg }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Varietas</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.idvarietas }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Varietas</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.varietas }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Jenis Tanah</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.jenistanah }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Kondisi Area</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.kondisiare }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Jenis Tebu</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.jenistebu }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Permohonan</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.permohonan }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Accept</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.accept_id }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">ID Koperasi</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.idkoperasi }}</div>
        </div>

        <div class="flex gap-2">
          <div class="whitespace-nowrap">Nama Koperasi</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.namakopera }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Afdeling</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.afdeling }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Afdeling Ma</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.afdelingma }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Afdeling I</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.afedling_i }}</div>
        </div>

        <div class="flex gap-2">
          <div class="w-[98px]">Status</div>
          <div class="w-[10px]">:</div>
          <div>{{ data.status }}</div>
        </div>
      </div>
    </div>
  </SidebarRight>
</template>
<script>
import IconGeofence from "@/components/icons/IconGeofence.vue";
import SidebarRight from "@/components/SidebarRight.vue";
import TitleSubIconGap from "@/components/TitleSubIconGap.vue";
import TittleBetween from "@/components/TittleBetween.vue";
import { useSidebarStore } from "@/store";
import { computed } from "vue";

export default {
  components: {
    SidebarRight,
    TitleSubIconGap,
    IconGeofence,
    TittleBetween,
  },
  setup() {
    const sidebar = useSidebarStore();

    const data = computed(() => sidebar.getData);

    return {
      data,
    };
  },
};
</script>
<style></style>
